export const SHELL_THEMES = [
  'default',
  'midnight',
  'lagoon',
  'emerald',
  'olive',
  'coral',
  'claret',
  'paper',
] as const;
export type ShellTheme = (typeof SHELL_THEMES)[number];
